import { useQuery } from '@tanstack/react-query';
import { integrationsService } from '@/services/integrations';

/**
 * `enabled` permite consultar o controle de emissão só quando a tela realmente
 * precisa dele (ex.: a tela da proposta só olha o controle para decidir se
 * mostra "Emitir manualmente"). A queryKey é a mesma da tela de Integrações, então
 * duas telas montadas na mesma sessão compartilham o cache em vez de duplicar a
 * chamada.
 */
export function useIntegrationDetails(
  policyId: string,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: ['integration-details', policyId],
    queryFn: async () => {
      const response =
        await integrationsService.getIntegrationDetails(policyId);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar detalhes da integração'
        );
      }
      return response.data;
    },
    enabled: !!policyId && (options?.enabled ?? true),
    staleTime: 1000 * 60 * 2,
  });
}
